<template>
  <div class="MainStepsForm">
    <!-- 父组件的内容 --><!-- 子路由会在这里渲染 -->
    <router-view v-if="bizType && bizType =='exist'"></router-view> <!-- 详情页面跳转过来显示文件下载页面 -->
    <div  v-show="tabIdx=='tab1' && !bizType" class="container">
      <a-alert
        message="平台为你自行上传的作品进行版权存证，不对您上传内容的真实性进行验证"
        type="warning"
        show-icon
      />
      <a-alert v-if="showAlert" type="info" show-icon closable @close="handleClose" style="margin-top: 16px;">
        <template #message>
          <div class="alert-content">
            <div class="alert-title">
              关于湖北省数字版权综合服务平台开通数据增值服务付费业务的通知
            </div>
            <div class="alert-desc-wrapper">
              <span class="alert-desc">
                为持续优化湖北省数字版权综合服务平台（以下简称"平台"）服务功能、提升平台运营质量、保障系统稳定运维与技术迭代升级，为广大用户提供更专业、高效、安全的数字化服务支撑，经统筹规划、审慎研究，平台自即日起开通数据增值服务付费业务。
              </span>
              <a-button type="link" class="detail-btn" @click="handleViewDetail">
                查看详情
              </a-button>
            </div>
          </div>
        </template>
      </a-alert>

      <div class="commonWhiteBg">
        <!-- <div class="ant-popover-arrow"></div> -->
        <div class="commonTitle"> 版权存证 </div>
        <div class="formWrap">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="125px"
          >
            <el-form-item
              label="作品名称"
              prop="subject"
            >
              <el-input v-model="form.subject"></el-input>
            </el-form-item>
           
            <!-- <el-form-item label="作者" class="personList" prop="author">
              <span v-for="(author, index) in form.author" :key="index">{{
                author.obligeeType == "1" ? author.userName : author.companyName
              }}</span>
              <el-button type="text" @click="isAuthorDialogVisible = true"
                >选择作者</el-button
              >
              <choose-person-dialog
                title="选择作者"
                v-if="isAuthorDialogVisible"
                v-model="form.author"
                :listOpt="obligees"
                :linkObj="{ label: '添加作者', path: '/Mine/RealName' }"
                @close="onSetAuthorDialogClose"
                @input="onChooseAuthor"
              ></choose-person-dialog>
            </el-form-item> -->
            <el-form-item
              label="作者"
              prop="author"
            >
              <el-input v-model="form.author"></el-input>
            </el-form-item>

            <el-form-item class="personList"  label="著作权人" prop="right">
              <span v-for="(author, index) in form.right" :key="index"
                >{{
                  author.obligeeType == "1"
                    ? author.userName
                    : author.companyName
                }}&nbsp;</span
              >
              <el-button type="text" @click="isRightDialogVisible = true"
                >选择权利人</el-button
              >
              <choose-person-dialog
                title="选择权利人"
                v-if="isRightDialogVisible"
                v-model="form.right"
                :listOpt="obligees"
                :linkObj="{ label: '添加权利人', path: '/Mine/Obligee' }"
                @close="onSetRightDialogClose"
                @input="onChooseRight"
              ></choose-person-dialog>
            </el-form-item>

            <el-form-item label="作品类型" prop="workCategory">     <!--  这里存证里面的参数名worksType 改为 workCategory -->
              <el-select
                  v-model="workCategoryText"
                  placeholder="请选择创作类型"
                  @change="selectworkCategory"
              >
                <el-option
                v-for="(item, index) in constants.worksType"
                :key="index"
                :label="item.label"
                :value="item"
                >
                </el-option>
              </el-select>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '1'">
                    <div slot="description" >
                      文字：小说、诗词、散文、论文等以文字形式表现的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '2'">
                    <div slot="description" >
                      口述：即兴的演说、授课、法庭辩论等以口头语言形式表现的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '3'">
                    <div slot="description" >
                      音乐：歌曲、交响乐等能够演唱或者演奏的带词或者不带词的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '4'">
                    <div slot="description" >
                      戏剧：话剧、歌剧、地方戏等供舞台演出的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '5'">
                    <div slot="description" >
                      曲艺：相声、快书、大鼓、评书等以说唱为主要形式表演的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '6'">
                    <div slot="description" >
                      舞蹈：通过连续的动作、姿势、表情等表现思想情感的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '7'">
                    <div slot="description" >
                      杂技：杂技、魔术、马戏等通过形体动作和技巧表现的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '8'">
                    <div slot="description" >
                      美术：绘画、书法、雕塑等以线条、色彩或者其他方式构成的有审美意义的平面或者立体的造型艺术作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '9'">
                    <div slot="description" >
                      建筑：以建筑物或者构筑物形式表现的有审美意义的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '10'">
                    <div slot="description" >
                      摄影：借助器械在感光材料或者其他介质上记录客观物体形象的艺术作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '11'">
                    <div slot="description" >
                      电影：是指摄制在一定介质上，由一系列有伴音或者无伴音的画面组成，并且借助适当装置放映或者以其他方式传播的作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '12'">
                    <div slot="description" >
                      类似摄制电影方法创作的作品：是指摄制在一定介质上，由一系列有伴音或者无伴音的画面组成，并且借助适当装置放映或者以其他方式传播的作品（电视剧，动画片，视频，录音、录像制品等都归于这一类）。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '13'">
                    <div slot="description" >
                      工程设计图、产品设计图：为施工、生产绘制的工程设计图、产品设计图，以及反映地理现象、说明事物原理或者结构的地图、示意图等作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '14'">
                    <div slot="description" >
                      地图、示意图：为施工、生产绘制的工程设计图、产品设计图，以及反映地理现象、说明事物原理或者结构的地图、示意图等作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '15'">
                    <div slot="description" >
                      模型：为展示、试验或者观测等用途，根据物体的形状和结构，按照一定比例制成的立体作品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '16'">
                    <div slot="description" >
                      录音制品：任何对表演的声音和其他声音的录制品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '17'">
                    <div slot="description" >
                      录像制品：电影作品和以类似摄制电影的方法创作的作品以外的任何有伴音或无伴音的连续相关形象、图像的制品。
                    </div>
              </a-alert>
              <a-alert class="tips" type="warning" v-if="form.workCategory == '18'">
                    <div slot="description" >
                      其他：根据法律法规规定的其他作品。选择“其他”类时，请说明具体情况。
                    </div>
              </a-alert>
            </el-form-item>
            <el-form-item label="创作性质" prop="creationNature">
                <el-select
                    v-model="creationNatureText"
                    placeholder="请选择作品创作性质"
                    @change="selectCreationNature"
                >
                    <el-option
                    v-for="(item, index) in constants.creationNature"
                    :key="index"
                    :label="item.label"
                    :value="index"
                    >
                    </el-option>
                </el-select>
                <a-alert class="tips" type="warning" v-if="form.creationNature == '1'">
                    <div slot="description">
                    作者未参考或使用已存在作品创作的作品。
                    </div>
                </a-alert>
                <a-alert class="tips" type="warning" v-if="form.creationNature == '2'">
                    <div slot="description">
                    作者参考已存在作品衍生创作的作品。
                    </div>
                </a-alert>
                <a-alert class="tips" type="warning" v-if="form.creationNature == '3'">
                    <div slot="description">
                    作者参考或使用已存在的外语作品衍生创作的作品。
                    </div>
                </a-alert>
                <a-alert class="tips" type="warning" v-if="form.creationNature == '4'">
                    <div slot="description">
                    作者参考或使用已存在作品衍生创作的系列。
                    </div>
                </a-alert>
                <a-alert class="tips" type="warning" v-if="form.creationNature == '5'">
                    <div slot="description">
                    作者使用已存在作品衍生创作的作品。
                    </div>
                </a-alert>
                <a-alert class="tips" type="warning" v-if="form.creationNature == '6'">
                    <div slot="description">
                    作者参考或使用已存在作品衍生创作的合集。
                    </div>
                </a-alert>
                <!-- <a-alert class="tips" type="warning" v-if="form.creationNature == '7'">
                    <div slot="description">
                    请添加作品性质说明。
                    </div>
                </a-alert> -->
              </el-form-item>

            <el-form-item
              label="上传作品"
              ref="uploader"
              class="uploadWraper"
               prop="files"
            >
              <el-upload
                class="commonUpload"
                drag
                :action="uploadUrl"
                :headers="uploadHeaders"
                :on-success="uploadSuccess"
                :on-remove="(file, fileList) => {handleRemove(file, fileList)}"
                 :before-upload="uploadBefore"
                multiple
                :file-list="fileList"
              >
                <div class="commonUploadInner">
                  <i class="iconfont iconUpload">&#xe606;</i>
                  <div class="el-upload__text">
                    <div>将文件拖到此处，或<em>点击上传</em></div>
                    <div style="line-height: 20px;font-size: 12px;padding: 0 20px;color: #89909B;"> 支持格式：.jpg｜.jpeg｜.gif｜.bmp｜.png｜.doc｜.docx｜.xls｜.xlsx｜.ppt｜.pptx｜.pdf｜.txt｜.wav｜.mp4｜.wmv｜.mp3｜.psd </div>
                  </div>
                </div>

              </el-upload>
              <a-alert
                class="tips"
                type="warning"
              >
                <div slot="message"> 温馨提示：</div>
                <div slot="description">1、同一批的存证文件归属于同一标签，不支持重置；<br>
                  2、支持文件批量上传，一次不能超过10个文件；<br>
                  3、文件永久保全。<br>
                  4、如需做版权登记，请在此处将证书及作品属性相关文件一并上传。<br>
                  5、超过100M的文件，存证收费将会相应增加。 </div>
              </a-alert>
            </el-form-item>
             <el-form-item
              label="存储保障"
            >
              <a-alert
                class="tipsGray"
              >
                <div slot="description">
                  1、只需花费三分钟即可免费办理的区块链存证证书；<br>
                  2、能够快速有效地固定作品信息。作品信息将被上传到区块链，获得精准授时，信息永久不可篡改。<br>
                  3、版权所有者日后进行版权授权交易及维权时，区块链存证证书都将成为有效的证据。<br>
                  4、同步上传多个主流链。
                </div>
              </a-alert>
            </el-form-item>
             <!-- <el-form-item label="支付方式" prop="paymode" class="choosePayStyle">
                <el-radio-group v-model="form.paymode">
                <el-radio label="vip"> <span class="onlyText">中国知链会员权益支付（当前存证次数可用{{vipInfo?vipInfo.existCount:0}}次）</span> </el-radio>
                <el-radio label="alipay"> <i class="iconfont aliPayColor"> &#xe634; </i> <span>支付宝支付</span></el-radio>
                 <el-radio label="wechat">  <i class="iconfont weChatColor"> &#xe633; </i> <span>微信支付</span></el-radio>
              </el-radio-group>
              <router-link class="buyVip" :to="{path:'/Vip'}">购买会员</router-link>
             </el-form-item>
             <el-form-item label="支付金额" v-if="form.paymode!='vip'">
              <div>  <em class="bigPrice">{{form.orderAmount}} </em> 元  </div>
            </el-form-item> -->
            <el-form-item label="支付方式" prop="paymode" class="choosePayStyle">
              <el-radio-group v-model="form.paymode">
                <el-radio label="vip"><span class="onlyText"> 会员权益支付（当前存证次数可用{{vipInfo ? vipInfo.existCount : 0}}次）</span></el-radio>
                <el-radio label="wechat">  <i class="iconfont weChatColor"> &#xe678; </i> <span>微信支付</span></el-radio>
                <el-radio label="alipay"> <i class="iconfont aliPayColor"> &#xe675; </i> <span>支付宝支付</span></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="支付金额" v-if="form.paymode != 'vip'" class="payMount">
              <div class="amount">
                <p>¥ {{ form.orderAmount }} </p>
              </div>
            </el-form-item>

            <el-form-item class="submitRow">
              <el-button
                type="primary"
                @click="onSubmit"
              >提交存证</el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>

    </div>
    <result-view  v-if="tabIdx=='tab2'" :orderInfo="form" @set-tab-idx="setTabIdx">
    </result-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import choosePersonDialog from "../../../components/form/choosePersonDialog";
import resultView from './components/resultView'
import { mixinsScrollErrorPosition } from '../../../mixins'
import multipleSelect from "../../../components/form/multipleSelect";
import constants from "@/utils/constants";
import request from '@/utils/request'

export default {
  name: 'ExistingEvidenceInputForm',
    mixins: [mixinsScrollErrorPosition],
  components: { resultView , choosePersonDialog , multipleSelect},
  data () {
    return {
      constants,
      userType: JSON.parse(localStorage.getItem('userInfo')).type,
      bizType: this.$route.query.bizType,
      workCategoryText:'',
      creationNatureText: '',
      form: {
        subject: '',
        paymode: 'vip',
        files:[],
        orderAmount: '0.00',
        author: '',
        right: [],
        workCategory: "",
        creationNature: "",
      },
      obligees: [],
      isAuthorDialogVisible: false,
      isRightDialogVisible: false,
      uploadUrl:`${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=exist/evidence/files/`,
      uploadHeaders:{ 
         'Authorization': this.$store.getters.token,
         'Product-Mode': "READ",
         'Terminal-Code': "IPCHAIN2"+ this.$store.getters.terminalCode,
         'Terminal-Type': "WEB",
         'Merchant-Id': "5"
         },
      fileList: [],
      uploadControllers: {},  // 修改为对象存储，key为文件uid，value为对应的控制器
      rules: {
        subject: [
          { required: true, message: '请输入作品名称', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ],
        workCategory: [
          { required: true, message: "请选择作品创作类型", trigger: "blur" },
        ],
        creationNature:[
          { required: true, message: "请选择作品创作性质", trigger: "blur" },
        ],
        files:[
           { required: true, message: '请上传作品', trigger: 'change' },
        ],
        author: [
          { required: true, message: '请选择作者', trigger: 'change' }
        ],
        right: [
          { required: true, message: '请选择权利人', trigger: 'blur' }
        ]
      },
      tabIdx: 'tab1',

      showAlert: true // 控制 alert 显示/隐藏
    }
  },
  computed: {
    ...mapGetters(['mid','userInfo','evidencePaymentPrice','vipInfo',"obligeeList"])
  },
  created() {
    this.loadData();

    // 打开页面请求会员权益信息
    this.bus.$emit("refreshVip");

    // 设置默认支付方式：如果 userType == 'N'，默认微信支付
    if (this.userType === 'N') {
      this.form.paymode = 'wechat';
    } else {
      // 非 N 类型，默认会员支付
      this.form.paymode = 'vip';
    }
  },
  // watch: {
  //   vipInfo: {
  //     handler(newValue) {
  //       if(newValue && newValue.vipType == 'C'){
  //         this.form.paymode = 'vip';
  //       }else{
  //         this.form.paymode = 'wechat';
  //       }
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  methods: {
      loadData() {
        if(this.obligeeList){
          this.obligees = this.obligeeList;
        }else{
          this.$message.error("获取著作权人列表失败")
          // 如果数据还未加载完成，可以设置监听或延迟检查
          const timer = setInterval(() => {
              if (this.obligeeList) {
                  this.obligees = this.obligeeList;
                  clearInterval(timer);
              }
          }, 100);
        }
      },
      async onSubmit () {
      console.log("onSubmit..")
      try {
        const formBaseResult = await this.$refs['form'].validate()
          if(this.form.files.length>10){
            this.$message.error("不能超过10个文件")
            return
          }
          // 检查VIP支付次数
          if (this.form.paymode === 'vip') {
            const availableCount = this.vipInfo ? this.vipInfo.existCount : 0;
            if (availableCount <= 0) {
              this.$message.warning('当前会员权益支付次数为0');
              return;
            }
          }
      } catch (error) {
        // 有错误,定位到错误
        // eslint-disable-next-line
        console.error(error)
        this.mixinsScrollView()
        return
      }
      this.setTabIdx('tab2')
     },
    setTabIdx(tabIdx){
        this.tabIdx=tabIdx
    },
    onSetAuthorDialogClose() {
        this.isAuthorDialogVisible = false;
      },
      onSetRightDialogClose() {
        this.isRightDialogVisible = false;
      },
      onChooseAuthor(users) {
        this.form.author = users;
      },
      onChooseRight(users) {
        this.form.right = users;
      },
    calAmount(){
       let amount=0;
       let existConfig=this.evidencePaymentPrice.exist.read;
       if(this.form.files.length > 0){
        for (let i = 0; i < this.form.files.length; i++) {
          const file = this.form.files[i];
          //
          // amount+=existConfig.basePrice*1+(Math.ceil(file.used*1/(1024*1024))* existConfig.sizePrice*1);
          amount = existConfig.amount*1;

        }
        }else{
          amount = '0.00'
        }

      //  this.form.orderAmount=(amount).toFixed(2);
       this.form.orderAmount = amount;
    },
    uploadBefore(file) {
        const allowedTypes = ['.jpg','.jpeg','.gif','.bmp','.png','.doc','.docx','.xls','.xlsx','.ppt','.pptx','.pdf','.txt','.wav','.mp4','.wmv','.mp3','.psd'];
        // 检查文件格式
        const ext = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(ext)) {
            this.$message.error('不支持的文件格式：' + ext);
            return false;
        }
        // 检查文件大小
        if (file.size > 100 * 1024 * 1024) {
            this.$message.error('文件大小不能超过100MB');
            return false;
        }
        // 大于10MB使用分片上传
        if (file.size > 10 * 1024 * 1024) {
            // console.log("上传文件大于10M，采用分片上传");
            setTimeout(() => this.chunkUpload(file), 0);// 延迟执行，避免阻塞UI
            return false;
        }
        // 小文件：继续普通上传
        return true;
			},
    uploadSuccess(response, file, fileList){
        console.log(arguments)
        this.$refs.uploader.clearValidate()
        this.form.files.push(response);
        this.calAmount();
    },
    handleRemove(file,fileList){
      // 中断该文件的上传（如果正在上传）
      this.abortUpload(file);
      // 1. 获取要删除的文件名
      const name = file.response ? `${file.response.sourceName}.${file.response.fileType}` : file.name;
      this.form.files = this.form.files.filter(file => {
        const fullName = file.sourceName + '.' + file.fileType;
        if (name.includes('.')) {
          return name !== fullName;  // 保留不匹配的文件，匹配的文件是删除的文件
        } else {
          return name !== file.sourceName;  // 保留不匹配的文件，匹配的文件是删除的文件
        }
      });
      // console.log(file,fileList);
      this.fileList = fileList
      // 更新价格
      this.calAmount();
    },

// 添加分片上传方法
async chunkUpload(file) {
  // 为当前文件创建独立的控制器
  const controller = new AbortController();
  this.uploadControllers[file.uid] = controller;
  // 检查是否已中断
  if (controller.signal.aborted) {
    throw new Error('上传已被中断');
  }
  // console.log('分片上传');
  try {
    // 1. 分片上传-1.获取上传ID /v1/ins/file/uploadId
    // 使用 Fetch API 上传
    const formData1 = new FormData()
    formData1.append('fileName', file.name)
    const randomPath = Math.random().toString(36).substring(2, 9)
    const uploadIdResponse = await fetch(`${process.env.VUE_APP_BASEURL}/v1/ins/file/uploadId?path=exist/evidence/files/${randomPath}` , {
      method: "POST",
      body: formData1,
      headers: this.uploadHeaders,
    });
    if (!uploadIdResponse.ok) throw new Error('获取上传ID失败');
    
    const uploadIdData = await uploadIdResponse.json();
    const uploadId = uploadIdData.uploadId;
    console.log('分片上传ID:',uploadId);
    
    // 2. 分片上传
    const chunkSize = 5 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / chunkSize);
    const partETags = []; // 存储每个分片的ETag，第三步需要的参数

    // 在fileList中添加文件项，并保存索引以便后续更新
    const fileItem = {
      name: `${file.name} （分片上传进度：0/${totalChunks})`,
      uid: file.uid,
      rawFile: file, // 保存原始文件对象以便标识
      status: 'uploading', // 设置上传中状态
      totalChunks: totalChunks,
      uploadedChunks: 0,
      percentage: 0 // 确保有 percentage 属性，初始为0
    };
    this.fileList.push(fileItem);

    for (let i = 0; i < totalChunks; i++) {
       // 每次循环前检查是否已中断
       if (controller.signal.aborted) {
        throw new Error('上传已被中断');
      }
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);
      const currentPartNumber = i + 1;
      // 更新进度显示
      const currentFileIndex = this.findFileIndex(file);
      if (currentFileIndex !== -1) {
        const uploadedChunks = i; // 当前已上传的分片数
        this.fileList[currentFileIndex].name = `${file.name} （分片上传进度：${uploadedChunks}/${totalChunks})`;
        this.fileList[currentFileIndex].percentage = Math.round((uploadedChunks / totalChunks) * 100);
        this.fileList[currentFileIndex].uploadedChunks = uploadedChunks;
      }
      // 参数：
      // currentPartNumber Number 是 1 当前分⽚号
      // currentPartSize Number 是 1048576// 当前分⽚⼤⼩，除了最后⼀个分⽚外，// 所有分⽚的⼤⼩都应该不⼩于5M，最后⼀个// 分⽚的⼤⼩不受限制
      // partNum Number 是 4 总分⽚⼤⼩
      // offset Number 是 0 分⽚偏移量，从零开始
      // file File 是 待分⽚⽂件
      const formData2 = new FormData();
      formData2.append('currentPartNumber', currentPartNumber);
      formData2.append('currentPartSize', chunk.size);
      formData2.append('partNum', totalChunks);
      formData2.append('offset', start); // 分片偏移量，从零开始
      formData2.append('file', chunk);
      // 等待当前分片上传完成，请求接口
      const uploadResponse = await fetch(`${process.env.VUE_APP_BASEURL}/v1/ins/file/uploadPart/${uploadId}?path=exist/evidence/files/${randomPath}`, {
        method: "POST",
        body: formData2,
        headers: this.uploadHeaders,
      });
      if (!uploadResponse.ok) throw new Error(`分片 ${currentPartNumber} 上传失败`);
      // 保存分片的ETag信息（根据实际接口返回字段调整）第三步需要使用的参数
      const partResult = await uploadResponse.json();
      if (partResult.eTag) {
        partETags.push({ partNumber: currentPartNumber, eTag: partResult.eTag });
      }

      // 更新进度显示（上传完成后）
      const currentFileIndex2 = this.findFileIndex(file);
      if (currentFileIndex2 !== -1) {
        const uploadedChunks = i + 1; // 当前已上传的分片数
        this.fileList[currentFileIndex2].name = `${file.name} （分片上传进度：${uploadedChunks}/${totalChunks})`;
        this.fileList[currentFileIndex2].percentage = Math.round((uploadedChunks / totalChunks) * 100);
        this.fileList[currentFileIndex2].uploadedChunks = uploadedChunks;
      }
      // 可选：显示上传进度
      console.log(`分片 ${currentPartNumber}/${totalChunks} 上传成功`);
    }
    
    // 再次检查是否中断（可能在最后一个分片上传后中断）
    if (controller.signal.aborted) {
      throw new Error('上传已被中断');
    }

    // 3. 合并分片// 参数：(上面接口返回) : parts:{"partNumber":1,"eTag":"6969fe670861dd98566165abcbeee01a"}
    // 上传完成后，更新为完成状态
    // 3. 合并分片
    // 使用 request API 上传,因为请求头需要Signature签名
    const mergeResponse = await request('POST', '/v1', `/ins/file/merge/${uploadId}`,partETags);
    // 这里你使用了 request API，但 mergeResponse 可能不是 Response 对象，只有使用 fetch，才能
    // if (!mergeResponse.ok) {
    //   throw new Error('合并分片失败');
    // }
    // const mergeResult = await mergeResponse.json();

    // 更新为完成状态
    const currentFileIndex3 = this.findFileIndex(file);
    if (currentFileIndex3 !== -1) {
      this.fileList[currentFileIndex3].name = `${file.name}`;  // 恢复为file.name便于删除匹配
      this.fileList[currentFileIndex3].percentage = 100;
      this.fileList[currentFileIndex3].status = 'success';
    }

    // 调用成功回调
    // this.uploadSuccess(mergeResult, file, []);
    this.uploadSuccess(mergeResponse.data, file, []);

    // 清理控制器
    delete this.uploadControllers[file.uid];

  } catch (error) {
      this.$message.error('分片上传失败');
      // 更新失败状态
      const currentFileIndex4 = this.findFileIndex(file);
      if (currentFileIndex4 !== -1) {
        this.fileList[currentFileIndex4].name = `${file.name} （上传失败）`;
        this.fileList[currentFileIndex4].percentage = 0;
        this.fileList[currentFileIndex4].status = 'fail';
      }
      this.fileList = [];
      // 清理控制器
      delete this.uploadControllers[file.uid];
  }
},
// 添加辅助方法：根据文件对象查找在fileList中的索引
findFileIndex(file) {
  return this.fileList.findIndex(item => item.rawFile === file );
},
// 添加中断上传的独立方法
abortUpload(file) {
  const fileUid = file.uid || file.rawFile?.uid;
  if (fileUid && this.uploadControllers[fileUid]) {
    console.log(`中断文件 ${file.name} 的上传`);
    this.uploadControllers[fileUid].abort();
    // 清理控制器
    delete this.uploadControllers[fileUid];
    // 更新文件状态
    const fileIndex = this.findFileIndex(file);
    if (fileIndex !== -1) {
      this.fileList[fileIndex].name = `${file.name} （已中断）`;
      this.fileList[fileIndex].status = 'fail';
      this.fileList[fileIndex].percentage = 0;
    }
    return true;
  }
  return false;
},

    // 选择作品类型
    selectworkCategory(selectedItem){
      this.workCategoryText = selectedItem.label;
      this.form.workCategory = selectedItem.value;
      // console.log(this.form.workCategory);
    },

    // 选择作品创作性质
    selectCreationNature(index){
      this.creationNatureText = this.constants.creationNature[index].label;
      this.form.creationNature = this.constants.creationNature[index].value;
    },

    // 付费通知弹窗相关
   handleViewDetail() {
      const routeUrl = this.$router.resolve({
        name: 'PaymentNotification',
      })
      // 在新窗口打开
      window.open(routeUrl.href, '_blank')
      // 关闭 alert
      this.showAlert = false
    },
    
    // 点击右上角关闭按钮的处理
    handleClose() {
      this.showAlert = false
    }

  },
  // beforeRouteLeave(to, from, next) {
  //   this.$confirm("系统可能不会保存您所做的更改。", "离开此页面？", {
  //     confirmButtonText: "离开",
  //     cancelButtonText: "取消",
  //     type: "warning"
  //   })
  //     .then(() => {
  //       // confirmButton回调
  //       next()
  //     })
  //     .catch(() => {
  //       // cancelButton回调，把当前页路由推回
  //       // 不能使用this.$router进行路由操作，会触发beforeRouteLeave导致死循环
  //       window.history.pushState("", "", this.currentUrl)
  //     })
  // },
}
</script>

<style lang='scss' scoped>
  @import "../../../assets/css/inputForm.scss";
.tips {
  // position: initial;
  position: absolute;
    width: 384px;
    right: -410px;
    top: 0;
}

// .el-radio-group{display: flex;align-items: center;}
.el-radio {
    color: #606266;
    font-weight: 500;
    cursor: pointer;
    margin-right: 30px!important;
    margin-bottom: 0!important;
}
.choosePayStyle /deep/.el-radio__label{border: none!important;}
.amount p{
    color: #316EF4;
    font-size: 22px;
}

.alert-content {
  width: 100%;
}
.alert-title {
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 14px;
}
.alert-desc {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.65);
}

.detail-btn {
  border: none;
  border-radius: 0;
  padding: 0;
  height: 20px;
  line-height: 20px;
  border-bottom: 1px solid #007DFF;
}

</style>
